module.exports = __webpack_public_path__ + "static/media/threestepiconactive1.9407e7d7.png";